import Injectable from '@/modules/shared/domain/di/injectable';
import { InterviewsRepository } from '../../domain/repositories/interviews-repository';

@Injectable()
export default class InterviewsDummyRepository implements InterviewsRepository {
  create(): Promise<void> {
    return Promise.resolve();
  }
}
